{
  "type": "object",
  "name": "voucher",
  "class": "py-4",
  "definitions": [
    {
      "type": "group",
      "control": "div",
      "title": "Belegdaten",
      "titleClass": "md:hidden",
      "cellClass": "md:hidden",
      "definitions": [
        {
          "type": "date",
          "title": "",
          "name": "belegdatum",
          "class": "color-light"
        },
        {
          "type": "entity",
          "title": "",
          "name": "konto",
          "endpoint": "",
          "format": "{{number}} - {{name}}",
          "class": "font-bold text-lg"
        },
        {
          "type": "string",
          "title": "Belegnummer: ",
          "name": "belegnummer"
        },
        {
          "type": "entity",
          "title": "Objekt: ",
          "name": "objekt",
          "endpoint": "",
          "format": "{{objekt}} - {{bezeichnung}}",
          "visible": {
            "name": "property",
            "property": "objekt",
            "rule": {
              "name": "not",
              "rule": {
                "name": "empty"
              }
            }
          }
        }
      ]
    },
    {
      "type": "date",
      "title": "Belegdatum",
      "name": "belegdatum",
      "titleClass": "hidden md:table-cell",
      "cellClass": "hidden md:table-cell whitespace-nowrap",
      "filter": {
        "title": "Belegdatum"
      },
      "sortable": {
        "title": "Belegdatum"
      }
    },
    {
      "type": "string",
      "title": "Belegnummer",
      "name": "belegnummer",
      "titleClass": "hidden md:table-cell",
      "cellClass": "hidden md:table-cell whitespace-nowrap",
      "filter": {
        "title": "Belegnummer"
      },
      "sortable": {
        "title": "Belegnummer"
      }
    },
    {
      "type": "entity",
      "title": "Kunde",
      "name": "konto",
      "endpoint": "",
      "format": "{{number}} - {{name}}",
      "class": "font-semibold",
      "titleClass": "hidden md:table-cell",
      "cellClass": "hidden md:table-cell",
      "filter": {
        "title": "Konto"
      },
      "sortable": {
        "title": "Konto"
      }
    },
    {
      "type": "entity",
      "title": "Objekt",
      "name": "objekt",
      "endpoint": "",
      "format": "{{objekt}} - {{bezeichnung}}",
      "titleClass": "hidden md:table-cell",
      "cellClass": "hidden md:table-cell",
      "filter": {
        "title": "Objekt"
      },
      "sortable": {
        "title": "Objekt"
      },
      "visible": {
        "name": "property",
        "property": "objekt",
        "rule": {
          "name": "not",
          "rule": {
            "name": "empty"
          }
        }
      }
    },
    {
      "type": "currency",
      "title": "Netto",
      "name": "gesamt",
      "codeName": "currency",
      "titleClass": "text-right",
      "cellClass": "text-right whitespace-nowrap",
      "filter": true,
      "sortable": true,
      "class": [
        {
          "class": "text-balance-negative",
          "rule": {
            "name": "property",
            "property": "gesamt",
            "rule": {
              "name": "number",
              "maxValue": 0
            }
          }
        }
      ]
    }
  ]
}
